/*@ngInject*/
const CreateFieldInstanceRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.createFieldInstance = function (formId, instance) {
        let url = '/rest/Field?formId=' + formId;

        return this.post(url, instance);
    };
};

angular.module('umFormViewer')
    .service('createFieldInstanceRepository', CreateFieldInstanceRepository);
